// Shimmer.jsx
// ─────────────────────────────────────────────────────────────────────────────
// Loading ke waqt dikhne wala ek chamakta block — kisi bhi page ke skeleton
// loader ke liye. Ek <Shimmer /> = ek bar/box/gola; inhe jod kar skeleton
// banta hai (dekho PounceLeadsPage/PounceLeadCardSkeleton).
//
//   <Shimmer width="60%" height={20} />        // text ki line
//   <Shimmer width={48} height={48} radius={12} /> // chaukor avatar
//   <Shimmer width={40} height={40} circle />   // gola
//
// Props:
//   width / height / radius — number (px) ya CSS string ("60%"). Default:
//                             poori chaudai, 16px unchai, 8px gol kinare.
//   circle                  — poora gol.
//   className               — sirf layout ke liye (margin, flex). Size hamesha
//                             props se do: do alag CSS files ka order pakka
//                             nahi hota, to class se diya size kabhi jeetta
//                             kabhi haarta.
// ─────────────────────────────────────────────────────────────────────────────
import React from "react";
import styles from "./Shimmer.module.css";

const toCss = (value) => (typeof value === "number" ? `${value}px` : value);

const Shimmer = ({ width, height, radius, circle = false, className = "" }) => {
  // Sirf diye gaye props ke variables set hote hain; baaki CSS ke default.
  const vars = {
    ...(width !== undefined && { "--shimmer-w": toCss(width) }),
    ...(height !== undefined && { "--shimmer-h": toCss(height) }),
    ...(radius !== undefined && { "--shimmer-r": toCss(radius) }),
  };

  return (
    <span
      className={`${styles.shimmer} ${circle ? styles.circle : ""} ${className}`}
      style={vars}
      aria-hidden="true"
    />
  );
};

export default Shimmer;
